import { invoiceActionTypes } from './invoiceActionTypes';
import i18n from 'src/i18n';
import { paymentApi } from 'services/http';
import { push } from 'react-router-redux';
// Actions
import {
  changeTab,
  loadAppointmentById
} from 'src/views/practitioner/Appointment/reducers/actions';
import { TAB_INVOICE } from 'services/constants';
import { alertError } from 'services/alerts';

//──── Invoice ───────────────────────────────────────────────────────────────────────────

export const loadAndSetInvoice = appointmentId => dispatch => {
  paymentApi
    .get('invoices/' + appointmentId)
    .then(({ data }) => {
      dispatch(setInvoice(data));
      // normalized services
      const activeServices = data.invoiceItems;
      if (activeServices && typeof activeServices === 'object' && activeServices.length) {
        for (let i = 0; i < activeServices.length; i++) {
          if (!activeServices[i].serviceId) {
            activeServices[i].serviceId = `${activeServices[i].name}`;
          }
          dispatch(addActiveService(activeServices[i]));
        }
      }
    })
    .catch(err => {
      const errRes = err.response;
      if (errRes && errRes.status === 404) {
        // we don't have invoice need load appointment first (for get practitioner id)
        dispatch(
          loadAppointmentById(appointmentId, null, activeAppointment => {
            if (activeAppointment.practitioner && activeAppointment.practitioner.id) {
              dispatch(
                loadAndSetServices(
                  activeAppointment.practitioner.id,
                  activeAppointment.campus && activeAppointment.campus.id
                )
              );
            }
          })
        );
      } else {
        dispatch(updateInvoiceServicesError());
      }
    });
};

const setInvoice = data => ({
  type: invoiceActionTypes.SET_INVOICE,
  payload: data
});

//──── Invoice Services ──────────────────────────────────────────────────────────────────

export const loadAndSetServices = (practitionerId, campusId) => dispatch => {
  paymentApi
    .get(`practitioners/${practitionerId}/services`)
    .then(({ data }) => {
      if (data && typeof data === 'object' && data.length) {
        const likeInvoiceService = data.map(el => {
          el.serviceId = el.id;
          return el;
        });
        dispatch(setServices(practitionerId, likeInvoiceService));
        //   set active service
        if (campusId) {
          for (let i = 0; i < data.length; i++) {
            if (
              Array.isArray(data[i].defaultCampusId) &&
              data[i].defaultCampusId.some(c => String(campusId) === String(c))
            ) {
              dispatch(addActiveService(data[i]));
            }
          }
        }
      } else {
        dispatch(setServicesError());
      }
    })
    .catch(() => {
      dispatch(setServicesError());
    });
};

const setServicesError = () => ({
  type: invoiceActionTypes.SET_INVOICE_SERVICES_ERROR
});

const setServices = (practitionerId, servicesList) => ({
  type: invoiceActionTypes.SET_INVOICE_SERVICES,
  payload: { practitionerId, servicesList }
});

export const addActiveService = activeService => ({
  type: invoiceActionTypes.ADD_ACTIVE_SERVICE,
  payload: activeService
});

export const removeActiveService = activeService => ({
  type: invoiceActionTypes.REMOVE_ACTIVE_SERVICE,
  payload: activeService
});

export const changeServicePrice = (serviceId, newPrice) => {
  return {
    type: invoiceActionTypes.CHANGE_SERVICE_PRICE,
    payload: { serviceId, newPrice }
  };
};

export const clearInvoice = () => ({
  type: invoiceActionTypes.RESET_INVOICE
});

//──── Save invoice ──────────────────────────────────────────────────────────────────────

export const saveNewInvoice = (appointmentId, services, isProdeo) => dispatch => {
  let body = {
    services,
    externalAppoitmentId: appointmentId,
    isProdeo
  };

  paymentApi
    .post('invoices', body)
    .then(() => {
      dispatch(changeTab(TAB_INVOICE));
      dispatch(loadAppointmentById(appointmentId));
      dispatch(push(`/practitioner/appointments/${appointmentId}/appointment`));
      dispatch(clearInvoice());
      dispatch(saveNewInvoicesSuccess());
    })
    .catch(() => {
      dispatch(saveNewInvoicesError());
      alertError();
    });
};

const saveNewInvoicesSuccess = () => ({
  type: invoiceActionTypes.SAVE_NEW_INVOICE_SUCCESS
});

const saveNewInvoicesError = () => ({
  type: invoiceActionTypes.SAVE_NEW_INVOICE_ERROR
});

//──── Update invoice ────────────────────────────────────────────────────────────────────

export const updateInvoiceServices = (invoiceData, services, isProdeo) => dispatch => {
  const body = { services, isProdeo };
  const headers = { rowVersion: invoiceData.rowVersion };

  paymentApi
    .put('invoices/' + invoiceData.invoiceId, body, { headers })
    .then(() => {
      dispatch(changeTab(TAB_INVOICE));
      dispatch(updateInvoiceRowVersion(Number(invoiceData.rowVersion) + 1));
      dispatch(updateInvoiceServicesSuccess());
      dispatch(push(`/practitioner/appointments/${invoiceData.appointmentId}/appointment`));
    })
    .catch(err => {
      const errRes = err.response;
      if (errRes && errRes.data && errRes.data.Codes && errRes.data.Codes.length) {
        const codesList = errRes.data.Codes;
        if (codesList.find(el => String(el) === '102')) {
          // invoice was updated other user
          alertError(i18n.t('toast_payment_changed_reception'));
        } else if (codesList.find(el => String(el) === '202')) {
          // user was starting paid invoice
          alertError(i18n.t('invoice_in_process_popup_text'));
        } else {
          alertError();
          dispatch(updateInvoiceServicesError());
        }
      } else {
        alertError();
        dispatch(updateInvoiceServicesError());
      }
    });
};

const updateInvoiceRowVersion = count => ({
  type: invoiceActionTypes.UPDATE_INVOICE_ROW_VERSION,
  payload: count
});

const updateInvoiceServicesError = () => ({
  type: invoiceActionTypes.UPDATE_INVOICE_ERROR
});

const updateInvoiceServicesSuccess = () => ({
  type: invoiceActionTypes.UPDATE_INVOICE_SUCCESS
});
